import(/* webpackMode: "eager" */ "/var/directorder/app/staging/apps/buyer/src/app/(auth)/login/[[...mode]]/page.js");
